import b64ToBlob from 'b64-to-blob'
import fileSaver from 'file-saver'

export const downloadFile = (url: string, filename: string) => {
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
}

export const downloadFileFromBase64 = (
  fileAsBase64: string,
  fileType: string,
  fileName: string
) => {
  const blob = b64ToBlob(fileAsBase64, fileType)
  fileSaver.saveAs(blob, fileName)
}

export const downloadFromUrl = async (url: string, filename: string) => {
  try {
    const response = await fetch(url)
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const blob = await response.blob()
    fileSaver.saveAs(blob, filename)
  } catch (error) {
    console.warn('Fallback to standard anchor download due to fetch error:', error)
    downloadFile(url, filename)
  }
}

